import { Dialog, DialogContent } from '@/components/ui/dialog';
import { TOrderWithRelation } from '@/types/order-type';
import { ReceiptPreviewCard } from './receipt';

interface ReceiptDialogProps {
  open: boolean;
  onOpenChange?: (open: boolean) => void;
  data?: TOrderWithRelation | null;
}

export function ReceiptDialog({ open, onOpenChange, data }: ReceiptDialogProps) {
  const order = data?.order;

  if (!order) {
    return null;
  }

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="p-0 overflow-visible max-w-fit">
        <ReceiptPreviewCard orderId={order.id} />
      </DialogContent>
    </Dialog>
  );
}
